var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path10, _g6, _path11, _g7, _path12, _g8, _path13, _g9, _path14, _g10, _path15, _g11, _path16, _g12, _path17, _g13, _path18, _g14, _path19, _g15, _path20, _g16, _path21, _g17, _path22, _g18, _path23, _g19, _path24, _g20, _path25, _g21, _path26, _g22, _path27, _g23, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g24, _g25, _g26, _path35, _path36, _g27, _path37, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoodle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_301366)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#DCC0AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 143.8C38 155.8 49.8 239.9 93.7 263.7C204.8 323.9 204.4 397 194.7 500H0V143.8Z",
    fill: "#DDB19E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.2 0H500V500H417.4C331 400.3 418.2 261.7 287.2 0Z",
    fill: "#DDB19E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.5 404.6C318.847 404.6 370.2 381.677 370.2 353.4C370.2 325.123 318.847 302.2 255.5 302.2C192.153 302.2 140.8 325.123 140.8 353.4C140.8 381.677 192.153 404.6 255.5 404.6Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.1 247.8C203.4 224.2 101.7 176.6 52.1 186.8C19.5 193.6 33.1 231.5 42.4 252.8C55.8 282.7 74.2 310 93.2 336.7C100.1 346.4 108.1 356.9 115.3 366.5C127.2 382.4 141.4 396.7 157.6 407.6C236.5 460.6 339.1 422 410.8 373.9C413.6 372 416.3 370 419 368C427.3 360.8 440.1 361.8 446.9 370.6C454.3 380 451 393.8 440.6 399.4C437.4 401.5 433.9 403.5 430.6 405.4C346.6 453.2 230.9 487.1 145.9 424C124.7 408.6 108.5 387.9 94.2 366.5C70.6 331.8 47.5 296.5 31.4 257.5C22.5 234.7 11 198.4 37.2 182.6C68.2 165.3 129.7 189.4 160.9 201.5C184.1 210.8 206.8 221.3 229.1 232.5C236.5 236.2 243.9 240 251.3 244C253.6 245.4 251.6 249.1 249.1 247.8Z",
    fill: "#FFE600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M403.9 252.6C402.3 338.9 319.9 408.3 220.2 380.7C120.5 353.1 85.5001 251.3 128.5 176.4L403.9 252.6Z",
    fill: "#6F5BA5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378 322.4C378.8 322.5 379.6 322.6 380.5 322.6C380.3 311.7 381.5 300.9 384 290.3C383.2 290.1 382.4 289.9 381.6 289.6C379.1 300.4 377.9 311.3 378 322.4Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.1 318.8C350.9 318.9 351.8 319.1 352.6 319.2C351.9 306.5 353 293.7 355.9 281.3C355.1 281 354.3 280.7 353.5 280.4C350.6 293 349.5 305.9 350.1 318.8Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.6 327.3C245.1 313.9 241.9 300.1 240.8 286.2C239.9 285.8 239.1 285.4 238.2 285C239.2 299.6 242.5 314.3 248.3 328.3C256.2 347.6 268 364.4 283 378.2C284.4 378.4 285.8 378.5 287.2 378.6C271.2 364.6 258.8 347.3 250.6 327.3Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.5 309.4C187.3 291.8 183.9 273.4 184.3 255.1C183.5 254.6 182.7 254.1 181.8 253.6C181.2 272.7 184.6 292 192.1 310.3C201.7 333.6 216.9 353.3 236.6 368.5C238.6 368.9 240.6 369.3 242.6 369.8C221.1 354.5 204.6 333.9 194.5 309.4Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.5 300.4C157.9 279.5 154.8 257.4 156.9 235.7C156.1 235.1 155.4 234.5 154.6 233.9C152.1 256.4 155.2 279.5 164.2 301.3C175.1 327.8 193.3 349.7 217.2 365.5C219 365.6 220.8 365.8 222.6 366.1C197.1 350.4 177.8 327.9 166.5 300.4Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.5 291.4C128.5 267 125.9 240.9 130.5 215.8C129.8 215.2 129 214.5 128.3 213.9C123.2 239.9 125.8 267 136.2 292.4C149.3 324.3 173 349.5 204.4 365.5C206.1 365.3 207.8 365.2 209.4 365.2C176.6 349.5 151.9 324.1 138.5 291.4Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.6 336.2C273.4 323.5 270.2 310.3 269 297.1C268.1 296.8 267.3 296.5 266.4 296.2C267.6 310 270.9 323.8 276.3 337.1C282.7 352.7 291.7 366.7 302.8 378.8C303.9 378.7 304.9 378.7 306 378.6C294.4 366.4 285.1 352.2 278.6 336.2Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.5 318.3C216.2 302.9 212.8 286.9 212.3 270.9C211.5 270.4 210.6 270 209.8 269.5C210.1 286.3 213.6 303.1 220.2 319.2C229 340.8 242.7 359.2 260.4 373.9C262.2 374.3 264 374.7 265.9 375.1C246.7 360.3 231.9 341 222.5 318.3Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.5 322.6C379.7 322.5 378.9 322.4 378 322.4C378.1 327.3 378.4 332.2 379 337.1C379.7 336.4 380.5 335.7 381.3 334.9C380.8 330.8 380.5 326.7 380.5 322.6Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.7 319.2C351.9 319.1 351 318.9 350.2 318.8C350.9 331.3 353.3 343.7 357.4 355.8C358.1 355.2 358.8 354.7 359.5 354.1C355.6 342.7 353.3 331 352.7 319.2Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.6 354.2C329.3 341.2 326 327.7 324.9 314.2C324 314 323.2 313.8 322.3 313.6C323.4 327.6 326.7 341.6 332.3 355.1C334.2 359.7 336.3 364.2 338.6 368.5C339.4 368.2 340.1 367.8 340.9 367.5C338.6 363.2 336.5 358.8 334.6 354.2Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.6 345.2C301.5 332.8 298.3 319.9 297 306.9C296.1 306.6 295.3 306.4 294.4 306.1C295.6 319.6 298.9 333.1 304.2 346.1C308.2 356 313.3 365.2 319.3 373.7C320.2 373.6 321.2 373.4 322.1 373.3C316 364.7 310.8 355.3 306.6 345.2Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.1 265.4C262.3 265.1 261.5 264.9 260.8 264.6C251.6 286 236.8 304.9 217.5 319.4C199.7 332.7 179.5 341.2 158 344.9C158.5 345.4 159 345.9 159.4 346.5C159.7 346.7 160 346.8 160.4 347C181.6 343.1 201.4 334.5 218.9 321.4C238.7 306.5 253.7 287.2 263.1 265.4Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317 288.2C316.2 287.9 315.5 287.5 314.7 287.2C305.4 306.7 291.4 323.9 273.5 337.3C253.3 352.4 230 361.4 205.1 364C206.5 364.7 207.9 365.4 209.3 366C233.1 362.8 255.5 353.9 275 339.3C293.2 325.5 307.5 308 317 288.2Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.3 276.3C289.5 276 288.8 275.6 288 275.3C278.8 296 264.3 314.2 245.4 328.3C225.9 342.9 203.5 351.7 179.7 354.7C180.8 355.3 181.7 356 182.4 356.9C205.8 353.6 227.8 344.7 247 330.3C266.1 315.9 280.8 297.4 290.3 276.3Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.3 300.6C342.6 300.2 341.8 299.9 341.1 299.5C331.9 317.6 318.5 333.6 301.5 346.2C280.1 362.2 255.2 371.3 228.6 373.3C230.6 374 232.6 374.6 234.6 375.2C259.4 372.4 282.7 363.3 302.9 348.1C320.2 335.3 333.8 319 343.3 300.6Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.7 239.1C177.9 238.8 177.1 238.6 176.3 238.3C167.1 259.4 152.4 278.1 133.2 292.4C128.4 296 123.4 299.2 118.3 302.1C118.7 302.8 119.1 303.5 119.5 304.3C124.7 301.4 129.8 298.1 134.6 294.4C154.4 279.8 169.4 260.7 178.7 239.1Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.5 355.2C307.7 371.5 282.3 380.6 255.2 382.4C256.4 382.9 257.6 383.3 258.7 383.8C259.2 384 259.6 384.2 260.1 384.5C285.8 382 310 372.8 330.9 357.2C346.9 345.2 359.9 330.3 369.2 313.4C368.5 313 367.7 312.7 367 312.3C357.9 328.8 345.2 343.4 329.5 355.2Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.9 247.7C206.1 247.5 205.3 247.2 204.5 247C195.3 268.2 180.6 287 161.3 301.4C151 309.1 139.8 315.2 128.1 319.7C128.1 319.7 128.1 319.8 128.2 319.8C129.3 319.9 131.6 320 132.7 320.1C132.7 320.3 132.7 320.4 132.7 320.6C143.3 316.2 153.4 310.5 162.8 303.4C182.5 288.6 197.5 269.5 206.9 247.7Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151 229.5C150.2 229.2 149.5 228.9 148.7 228.6C139.9 249.1 126 267.3 107.8 281.5C108.2 282.3 108.5 283 108.9 283.8C127.6 269.3 142 250.6 151 229.5Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.9 219.1C115.3 232.3 107.6 244.5 98 255.4C98.2 256.4 98.5 257.3 98.8 258.2C109.1 246.8 117.3 233.9 123.2 220C122.4 219.8 121.7 219.4 120.9 219.1Z",
    fill: "#53447C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 173,
    width: 294,
    height: 211
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M404.7 249.7C403.1 336 320.7 405.4 221 377.8C121.3 350.2 86.3001 248.3 129.4 173.5L404.7 249.7Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.1 256.2C234.3 256 233.5 255.7 232.7 255.5C223.5 276.9 208.7 295.9 189.3 310.4C174.5 321.5 158 329.2 140.5 333.6C141.2 334.3 141.8 335 142.4 335.7C159.8 331.2 176.1 323.4 190.8 312.4C210.7 297.5 225.8 278.1 235.1 256.2Z",
    fill: "#53447C"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M384.1 320.8C353.6 370.7 291.3 400.4 220.2 380.7C149.1 361 110.9 303.6 110.5 245.1C121.7 297 161 343.8 225.5 361.6C290 379.4 347.8 359.6 384.1 320.8Z",
    fill: "#53447C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M127.2 176.4C152.7 143.4 219.5 134.7 281.2 150.5C342.9 166.3 397.2 206.3 403.6 247.5C412 301.1 339.8 337.2 239.8 311.5C139.8 285.8 93.9 219.3 127.2 176.4Z",
    fill: "#F1683D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M300 325.8C280.4 325.8 259.4 323 238.2 317.6C206.9 309.6 179 296.6 157.4 280.3C136.8 264.7 122.4 246.4 115.6 227.4C107.9 205.6 110.8 183.9 123.8 166.3C137.3 148 160.9 135.3 191.9 129.7C220.8 124.5 254.1 126 285.4 134.1C316.8 142.2 346.6 156.8 369.4 175.4C393.9 195.3 408.4 217.7 411.4 240.3C414.3 262 406.4 282.4 389.1 297.8C374 311.2 352.5 320.3 327 324C318.4 325.1 309.4 325.8 300 325.8ZM227.3 139C215.9 139 204.7 139.9 194.2 141.8C166.8 146.8 145.3 158 133.9 173.5C123.3 187.9 121 205 127.4 223C140.2 259 183.9 290.6 241.4 305.4C298.9 320.2 352.4 313.6 381 288.3C395.3 275.6 401.6 259.5 399.2 241.8C396.6 222.7 383.3 202.5 361.7 184.9C340.2 167.5 312.1 153.6 282.4 146C264.2 141.4 245.4 139 227.3 139Z",
    fill: "#D8D0E7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M396.3 264.4C397 259.7 397 260.6 396.1 255.4C389.3 218.7 337.9 179.5 279.1 164.8C177.5 139.4 139.1 178.9 125 209.3C122.8 214 124.1 188.4 129.3 181.5C153.9 149.1 223.6 136.7 282.4 151.9C341.2 167 392.7 205.7 398.5 246C399.8 254.5 398.9 256.9 396.3 264.4Z",
    fill: "#C9502F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M396.3 264.4C397 259.7 397.5 253 396.5 247.8C389.7 211.1 338.1 172.7 279.4 157.6C220.6 142.5 156.9 151.2 133.3 180.1C130 184.1 127.1 187.8 125.5 192.2C126.8 184.4 130.5 177.5 135.8 170.5C160.4 138.1 224.1 129 282.9 144.2C341.7 159.3 393.2 198 399 238.3C400.3 246.9 400.2 257.4 396.3 264.4Z",
    fill: "#53447C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 187.7C172.8 187.7 208.8 149.5 222.8 152.1C236.7 154.7 242 136.2 265.8 144.1C278.8 148.5 273.4 166.3 281.3 169.5C289.2 172.7 266.7 212 264.7 226.4C262.7 240.8 257.6 252.6 257.6 252.6L172.8 187.7Z",
    fill: "#F1683D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M393.1 249.6C393.1 249.6 377.7 181.4 368.7 170.5C359.7 159.6 360.6 180.6 350.7 190C340.8 199.4 319.5 182.5 312.9 177.2C306.2 171.9 294.9 161.3 283.3 170.1C271.7 178.8 263.8 189.1 263.8 189.1L393.1 249.6Z",
    fill: "#F1683D"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.1 251.9C343.611 251.9 349.7 245.811 349.7 238.3C349.7 230.789 343.611 224.7 336.1 224.7C328.589 224.7 322.5 230.789 322.5 238.3C322.5 245.811 328.589 251.9 336.1 251.9Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.5 215.7C172.011 215.7 178.1 209.611 178.1 202.1C178.1 194.589 172.011 188.5 164.5 188.5C156.989 188.5 150.9 194.589 150.9 202.1C150.9 209.611 156.989 215.7 164.5 215.7Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.7 270.3C201.211 270.3 207.3 264.211 207.3 256.7C207.3 249.189 201.211 243.1 193.7 243.1C186.189 243.1 180.1 249.189 180.1 256.7C180.1 264.211 186.189 270.3 193.7 270.3Z",
    fill: "white"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.3 97.9L435.8 74.4C439.7 74.2 443 75.8 443.1 78.1L443.4 82.6C443.5 84.9 440.5 87 436.6 87.2L130.5 101.9C128.7 102 127.1 101.2 127 100.1C127 99 128.4 98 130.3 97.9Z",
    fill: "#115249"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_20280_301366",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 29,
    width: 325,
    height: 252
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5 280.9C349.081 280.9 421.7 224.667 421.7 155.3C421.7 85.9331 349.081 29.7 259.5 29.7C169.919 29.7 97.3 85.9331 97.3 155.3C97.3 224.667 169.919 280.9 259.5 280.9Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_20280_301366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.8 350.2C237.9 350.6 236.1 349.5 235.8 347.9C234.7 341.9 238.1 338.1 240.9 335C243.6 332 245.1 330.2 244.5 327C243.9 323.8 241.8 322.7 238.2 320.9C234.5 319.1 229.9 316.8 228.8 310.8C227.7 304.8 231.1 301 233.9 297.9C236.6 294.9 238.1 293.1 237.5 289.9C236.9 286.7 234.8 285.6 231.2 283.8C227.5 282 222.9 279.7 221.8 273.7C220.7 267.7 224.1 263.9 226.9 260.8C229.6 257.8 231.1 256 230.5 252.8C229.9 249.6 227.8 248.5 224.2 246.7C220.5 244.9 215.9 242.6 214.8 236.6C213.7 230.6 217.1 226.8 219.9 223.7C222.6 220.7 224.1 218.9 223.5 215.7C222.9 212.5 220.8 211.4 217.2 209.6C213.5 207.8 208.9 205.5 207.8 199.5C206.7 193.5 210.1 189.7 212.9 186.6C215.6 183.6 217.1 181.8 216.5 178.6C215.9 175.4 213.8 174.3 210.2 172.5C206.5 170.7 201.9 168.4 200.8 162.4C199.7 156.4 203.1 152.6 205.9 149.5C208.6 146.5 210.1 144.7 209.5 141.5C208.9 138.3 206.8 137.2 203.2 135.4C199.5 133.6 194.9 131.3 193.8 125.3C192.7 119.3 196.1 115.5 198.9 112.4C201.6 109.4 203.1 107.6 202.5 104.4C201.9 101.2 199.8 100.1 196.2 98.3C192.5 96.5 187.9 94.2 186.8 88.2C185.7 82.2 189.1 78.4 191.9 75.3C194.6 72.3 196.1 70.5 195.5 67.3C195.2 65.7 196.5 64 198.4 63.7C200.3 63.4 202.1 64.4 202.4 66C203.5 72 200.1 75.8 197.3 78.9C194.6 81.9 193.1 83.7 193.7 86.9C194.3 90.1 196.4 91.2 200 93C203.7 94.8 208.3 97.1 209.4 103.1C210.5 109.1 207.1 112.9 204.3 116C201.6 119 200.1 120.8 200.7 124C201.3 127.2 203.4 128.3 207 130.1C210.7 131.9 215.3 134.2 216.4 140.2C217.5 146.2 214.1 150 211.3 153.1C208.6 156.1 207.1 157.9 207.7 161.1C208.3 164.3 210.4 165.4 214 167.2C217.7 169 222.3 171.3 223.4 177.3C224.5 183.3 221.1 187.1 218.3 190.2C215.6 193.2 214.1 195 214.7 198.2C215.3 201.4 217.4 202.5 221 204.3C224.7 206.1 229.3 208.4 230.4 214.4C231.5 220.4 228.1 224.2 225.3 227.3C222.6 230.3 221.1 232.1 221.7 235.3C222.3 238.5 224.4 239.6 228 241.4C231.7 243.2 236.3 245.5 237.4 251.5C238.5 257.5 235.1 261.3 232.3 264.4C229.6 267.4 228.1 269.2 228.7 272.4C229.3 275.6 231.4 276.7 235 278.5C238.7 280.3 243.3 282.6 244.4 288.6C245.5 294.6 242.1 298.4 239.3 301.5C236.6 304.5 235.1 306.3 235.7 309.5C236.3 312.7 238.4 313.8 242 315.6C245.7 317.4 250.3 319.7 251.4 325.7C252.5 331.7 249.1 335.5 246.3 338.6C243.6 341.6 242.1 343.4 242.7 346.6C243 348.2 241.7 349.9 239.8 350.2Z",
    fill: "#EFE7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2 347.5C252.3 347.9 250.5 346.8 250.2 345.2C249.1 339.2 252.5 335.4 255.3 332.3C258 329.3 259.5 327.5 258.9 324.3C258.3 321.1 256.2 320 252.6 318.2C248.9 316.4 244.3 314.1 243.2 308.1C242.1 302.1 245.5 298.3 248.3 295.2C251 292.2 252.5 290.4 251.9 287.2C251.3 284 249.2 282.9 245.6 281.1C241.9 279.3 237.3 277 236.2 271C235.1 265 238.5 261.2 241.3 258.1C244 255.1 245.5 253.3 244.9 250.1C244.3 246.9 242.2 245.8 238.6 244C234.9 242.2 230.3 239.9 229.2 233.9C228.1 227.9 231.5 224.1 234.3 221C237 218 238.5 216.2 237.9 213C237.3 209.8 235.2 208.7 231.6 206.9C227.9 205.1 223.3 202.8 222.2 196.8C221.1 190.8 224.5 187 227.3 183.9C230 180.9 231.5 179.1 230.9 175.9C230.3 172.7 228.2 171.6 224.6 169.8C220.9 168 216.3 165.7 215.2 159.7C214.1 153.7 217.5 149.9 220.3 146.8C223 143.8 224.5 142 223.9 138.8C223.3 135.6 221.2 134.5 217.6 132.7C213.9 130.9 209.3 128.6 208.2 122.6C207.1 116.6 210.5 112.8 213.3 109.7C216 106.7 217.5 104.9 216.9 101.7C216.3 98.5 214.2 97.4 210.6 95.6C206.9 93.8 202.3 91.5 201.2 85.5C200.1 79.5 203.5 75.7 206.3 72.6C209 69.6 210.5 67.8 209.9 64.6C209.6 63 210.9 61.3 212.8 61C214.7 60.6 216.5 61.7 216.8 63.3C217.9 69.3 214.5 73.1 211.7 76.2C209 79.2 207.5 81 208.1 84.2C208.7 87.4 210.8 88.5 214.4 90.3C218.1 92.1 222.7 94.4 223.8 100.4C224.9 106.4 221.5 110.2 218.7 113.3C216 116.3 214.5 118.1 215.1 121.3C215.7 124.5 217.8 125.6 221.4 127.4C225.1 129.2 229.7 131.5 230.8 137.5C231.9 143.5 228.5 147.3 225.7 150.4C223 153.4 221.5 155.2 222.1 158.4C222.7 161.6 224.8 162.7 228.4 164.5C232.1 166.3 236.7 168.6 237.8 174.6C238.9 180.6 235.5 184.4 232.7 187.5C230 190.5 228.5 192.3 229.1 195.5C229.7 198.7 231.8 199.8 235.4 201.6C239.1 203.4 243.7 205.7 244.8 211.7C245.9 217.7 242.5 221.5 239.7 224.6C237 227.6 235.5 229.4 236.1 232.6C236.7 235.8 238.8 236.9 242.4 238.7C246.1 240.5 250.7 242.8 251.8 248.8C252.9 254.8 249.5 258.6 246.7 261.7C244 264.7 242.5 266.5 243.1 269.7C243.7 272.9 245.8 274 249.4 275.8C253.1 277.6 257.7 279.9 258.8 285.9C259.9 291.9 256.5 295.7 253.7 298.8C251 301.8 249.5 303.6 250.1 306.8C250.7 310 252.8 311.1 256.4 312.9C260.1 314.7 264.7 317 265.8 323C266.9 329 263.5 332.8 260.7 335.9C258 338.9 256.5 340.7 257.1 343.9C257.4 345.5 256.1 347.1 254.2 347.5Z",
    fill: "#EDDABE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.9 339.2C296 339.6 294.2 338.5 293.9 336.9C292.8 330.9 296.2 327.1 299 324C301.7 321 303.2 319.2 302.6 316C302 312.8 299.9 311.7 296.3 309.9C292.6 308.1 288 305.8 286.9 299.8C285.8 293.8 289.2 290 292 286.9C294.7 283.9 296.2 282.1 295.6 278.9C295 275.7 292.9 274.6 289.3 272.8C285.6 271 281 268.7 279.9 262.7C278.8 256.7 282.2 252.9 285 249.8C287.7 246.8 289.2 245 288.6 241.8C288 238.6 285.9 237.5 282.3 235.7C278.6 233.9 274 231.6 272.9 225.6C271.8 219.6 275.2 215.8 278 212.7C280.7 209.7 282.2 207.9 281.6 204.7C281 201.5 278.9 200.4 275.3 198.6C271.6 196.8 267 194.5 265.9 188.5C264.8 182.5 268.2 178.7 271 175.6C273.7 172.6 275.2 170.8 274.6 167.6C274 164.4 271.9 163.3 268.3 161.5C264.6 159.7 260 157.4 258.9 151.4C257.8 145.4 261.2 141.6 264 138.5C266.7 135.5 268.2 133.7 267.6 130.5C267 127.3 264.9 126.2 261.3 124.4C257.6 122.6 253 120.3 251.9 114.3C250.8 108.3 254.2 104.5 257 101.4C259.7 98.4 261.2 96.6 260.6 93.4C260 90.2 257.9 89.1 254.3 87.3C250.6 85.5 246 83.2 244.9 77.2C243.8 71.2 247.2 67.4 250 64.3C252.7 61.3 254.2 59.5 253.6 56.3C253.3 54.7 254.6 53 256.5 52.7C258.4 52.3 260.2 53.4 260.5 55C261.6 61 258.2 64.8 255.4 67.9C252.7 70.9 251.2 72.7 251.8 75.9C252.4 79.1 254.5 80.2 258.1 82C261.8 83.8 266.4 86.1 267.5 92.1C268.6 98.1 265.2 101.9 262.4 105C259.7 108 258.2 109.8 258.8 113C259.4 116.2 261.5 117.3 265.1 119.1C268.8 120.9 273.4 123.2 274.5 129.2C275.6 135.2 272.2 139 269.4 142.1C266.7 145.1 265.2 146.9 265.8 150.1C266.4 153.3 268.5 154.4 272.1 156.2C275.8 158 280.4 160.3 281.5 166.3C282.6 172.3 279.2 176.1 276.4 179.2C273.7 182.2 272.2 184 272.8 187.2C273.4 190.4 275.5 191.5 279.1 193.3C282.8 195.1 287.4 197.4 288.5 203.4C289.6 209.4 286.2 213.2 283.4 216.3C280.7 219.3 279.2 221.1 279.8 224.3C280.4 227.5 282.5 228.6 286.1 230.4C289.8 232.2 294.4 234.5 295.5 240.5C296.6 246.5 293.2 250.3 290.4 253.4C287.7 256.4 286.2 258.2 286.8 261.4C287.4 264.6 289.5 265.7 293.1 267.5C296.8 269.3 301.4 271.6 302.5 277.6C303.6 283.6 300.2 287.4 297.4 290.5C294.7 293.5 293.2 295.3 293.8 298.5C294.4 301.7 296.5 302.8 300.1 304.6C303.8 306.4 308.4 308.7 309.5 314.7C310.6 320.7 307.2 324.5 304.4 327.6C301.7 330.6 300.2 332.4 300.8 335.6C301.2 337.2 299.8 338.8 297.9 339.2Z",
    fill: "#EFE7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.3 336.4C310.4 336.8 308.6 335.7 308.3 334.1C307.2 328.1 310.6 324.3 313.4 321.2C316.1 318.2 317.6 316.4 317 313.2C316.4 310 314.3 308.9 310.7 307.1C307 305.3 302.4 303 301.3 297C300.2 291 303.6 287.2 306.4 284.1C309.1 281.1 310.6 279.3 310 276.1C309.4 272.9 307.3 271.8 303.7 270C300 268.2 295.4 265.9 294.3 259.9C293.2 253.9 296.6 250.1 299.4 247C302.1 244 303.6 242.2 303 239C302.4 235.8 300.3 234.7 296.7 232.9C293 231.1 288.4 228.8 287.3 222.8C286.2 216.8 289.6 213 292.4 209.9C295.1 206.9 296.6 205.1 296 201.9C295.4 198.7 293.3 197.6 289.7 195.8C286 194 281.4 191.7 280.3 185.7C279.2 179.7 282.6 175.9 285.4 172.8C288.1 169.8 289.6 168 289 164.8C288.4 161.6 286.3 160.5 282.7 158.7C279 156.9 274.4 154.6 273.3 148.6C272.2 142.6 275.6 138.8 278.4 135.7C281.1 132.7 282.6 130.9 282 127.7C281.4 124.5 279.3 123.4 275.7 121.6C272 119.8 267.4 117.5 266.3 111.5C265.2 105.5 268.6 101.7 271.4 98.6C274.1 95.6 275.6 93.8 275 90.6C274.4 87.4 272.3 86.3 268.7 84.5C265 82.7 260.4 80.4 259.3 74.4C258.2 68.4 261.6 64.6 264.4 61.5C267.1 58.5 268.6 56.7 268 53.5C267.7 51.9 269 50.2 270.9 49.9C272.8 49.5 274.6 50.6 274.9 52.2C276 58.2 272.6 62 269.8 65.1C267.1 68.1 265.6 69.9 266.2 73.1C266.8 76.3 268.9 77.4 272.5 79.2C276.2 81 280.8 83.3 281.9 89.3C283 95.3 279.6 99.1 276.8 102.2C274.1 105.2 272.6 107 273.2 110.2C273.8 113.4 275.9 114.5 279.5 116.3C283.2 118.1 287.8 120.4 288.9 126.4C290 132.4 286.6 136.2 283.8 139.3C281.1 142.3 279.6 144.1 280.2 147.3C280.8 150.5 282.9 151.6 286.5 153.4C290.2 155.2 294.8 157.5 295.9 163.5C297 169.5 293.6 173.3 290.8 176.4C288.1 179.4 286.6 181.2 287.2 184.4C287.8 187.6 289.9 188.7 293.5 190.5C297.2 192.3 301.8 194.6 302.9 200.6C304 206.6 300.6 210.4 297.8 213.5C295.1 216.5 293.6 218.3 294.2 221.5C294.8 224.7 296.9 225.8 300.5 227.6C304.2 229.4 308.8 231.7 309.9 237.7C311 243.7 307.6 247.5 304.8 250.6C302.1 253.6 300.6 255.4 301.2 258.6C301.8 261.8 303.9 262.9 307.5 264.7C311.2 266.5 315.8 268.8 316.9 274.8C318 280.8 314.6 284.6 311.8 287.7C309.1 290.7 307.6 292.5 308.2 295.7C308.8 298.9 310.9 300 314.5 301.8C318.2 303.6 322.8 305.9 323.9 311.9C325 317.9 321.6 321.7 318.8 324.8C316.1 327.8 314.6 329.6 315.2 332.8C315.5 334.4 314.2 336.1 312.3 336.4Z",
    fill: "#EDDABE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9 344.7C267 345.1 265.2 344 264.9 342.4C263.8 336.4 267.2 332.6 270 329.5C272.7 326.5 274.2 324.7 273.6 321.5C273 318.3 270.9 317.2 267.3 315.4C263.6 313.6 259 311.3 257.9 305.3C256.8 299.3 260.2 295.5 263 292.4C265.7 289.4 267.2 287.6 266.6 284.4C266 281.2 263.9 280.1 260.3 278.3C256.6 276.5 252 274.2 250.9 268.2C249.8 262.2 253.2 258.4 256 255.3C258.7 252.3 260.2 250.5 259.6 247.3C259 244.1 256.9 243 253.3 241.2C249.6 239.4 245 237.1 243.9 231.1C242.8 225.1 246.2 221.3 249 218.2C251.7 215.2 253.2 213.4 252.6 210.2C252 207 249.9 205.9 246.3 204.1C242.6 202.3 238 200 236.9 194C235.8 188 239.2 184.2 242 181.1C244.7 178.1 246.2 176.3 245.6 173.1C245 169.9 242.9 168.8 239.3 167C235.6 165.2 231 162.9 229.9 156.9C228.8 150.9 232.2 147.1 235 144C237.7 141 239.2 139.2 238.6 136C238 132.8 235.9 131.7 232.3 129.9C228.6 128.1 224 125.8 222.9 119.8C221.8 113.8 225.2 110 228 106.9C230.7 103.9 232.2 102.1 231.6 98.9C231 95.7 228.9 94.6 225.3 92.8C221.6 91 217 88.7 215.9 82.7C214.8 76.7 218.2 72.9 221 69.8C223.7 66.8 225.2 65 224.6 61.8C224.3 60.2 225.6 58.5 227.5 58.2C229.4 57.8 231.2 58.9 231.5 60.5C232.6 66.5 229.2 70.3 226.4 73.4C223.7 76.4 222.2 78.2 222.8 81.4C223.4 84.6 225.5 85.7 229.1 87.5C232.8 89.3 237.4 91.6 238.5 97.6C239.6 103.6 236.2 107.4 233.4 110.5C230.7 113.5 229.2 115.3 229.8 118.5C230.4 121.7 232.5 122.8 236.1 124.6C239.8 126.4 244.4 128.7 245.5 134.7C246.6 140.7 243.2 144.5 240.4 147.6C237.7 150.6 236.2 152.4 236.8 155.6C237.4 158.8 239.5 159.9 243.1 161.7C246.8 163.5 251.4 165.8 252.5 171.8C253.6 177.8 250.2 181.6 247.4 184.7C244.7 187.7 243.2 189.5 243.8 192.7C244.4 195.9 246.5 197 250.1 198.8C253.8 200.6 258.4 202.9 259.5 208.9C260.6 214.9 257.2 218.7 254.4 221.8C251.7 224.8 250.2 226.6 250.8 229.8C251.4 233 253.5 234.1 257.1 235.9C260.8 237.7 265.4 240 266.5 246C267.6 252 264.2 255.8 261.4 258.9C258.7 261.9 257.2 263.7 257.8 266.9C258.4 270.1 260.5 271.2 264.1 273C267.8 274.8 272.4 277.1 273.5 283.1C274.6 289.1 271.2 292.9 268.4 296C265.7 299 264.2 300.8 264.8 304C265.4 307.2 267.5 308.3 271.1 310.1C274.8 311.9 279.4 314.2 280.5 320.2C281.6 326.2 278.2 330 275.4 333.1C272.7 336.1 271.2 337.9 271.8 341.1C272.1 342.7 270.8 344.3 268.9 344.7Z",
    fill: "#EFE7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.2 342C281.3 342.4 279.5 341.3 279.2 339.7C278.1 333.7 281.5 329.9 284.3 326.8C287 323.8 288.5 322 287.9 318.8C287.3 315.6 285.2 314.5 281.6 312.7C277.9 310.9 273.3 308.6 272.2 302.6C271.1 296.6 274.5 292.8 277.3 289.7C280 286.7 281.5 284.9 280.9 281.7C280.3 278.5 278.2 277.4 274.6 275.6C270.9 273.8 266.3 271.5 265.2 265.5C264.1 259.5 267.5 255.7 270.3 252.6C273 249.6 274.5 247.8 273.9 244.6C273.3 241.4 271.2 240.3 267.6 238.5C263.9 236.7 259.3 234.4 258.2 228.4C257.1 222.4 260.5 218.6 263.3 215.5C266 212.5 267.5 210.7 266.9 207.5C266.3 204.3 264.2 203.2 260.6 201.4C256.9 199.6 252.3 197.3 251.2 191.3C250.1 185.3 253.5 181.5 256.3 178.4C259 175.4 260.5 173.6 259.9 170.4C259.3 167.2 257.2 166.1 253.6 164.3C249.9 162.5 245.3 160.2 244.2 154.2C243.1 148.2 246.5 144.4 249.3 141.3C252 138.3 253.5 136.5 252.9 133.3C252.3 130.1 250.2 129 246.6 127.2C242.9 125.4 238.3 123.1 237.2 117.1C236.1 111.1 239.5 107.3 242.3 104.2C245 101.2 246.5 99.4 245.9 96.2C245.3 93 243.2 91.9 239.6 90.1C235.9 88.3 231.3 86 230.2 80C229.1 74 232.5 70.2 235.3 67.1C238 64.1 239.5 62.3 238.9 59.1C238.6 57.5 239.9 55.8 241.8 55.5C243.7 55.2 245.5 56.2 245.8 57.8C246.9 63.8 243.5 67.6 240.7 70.7C238 73.7 236.5 75.5 237.1 78.7C237.7 81.9 239.8 83 243.4 84.8C247.1 86.6 251.7 88.9 252.8 94.9C253.9 100.9 250.5 104.7 247.7 107.8C245 110.8 243.5 112.6 244.1 115.8C244.7 119 246.8 120.1 250.4 121.9C254.1 123.7 258.7 126 259.8 132C260.9 138 257.5 141.8 254.7 144.9C252 147.9 250.5 149.7 251.1 152.9C251.7 156.1 253.8 157.2 257.4 159C261.1 160.8 265.7 163.1 266.8 169.1C267.9 175.1 264.5 178.9 261.7 182C259 185 257.5 186.8 258.1 190C258.7 193.2 260.8 194.3 264.4 196.1C268.1 197.9 272.7 200.2 273.8 206.2C274.9 212.2 271.5 216 268.7 219.1C266 222.1 264.5 223.9 265.1 227.1C265.7 230.3 267.8 231.4 271.4 233.2C275.1 235 279.7 237.3 280.8 243.3C281.9 249.3 278.5 253.1 275.7 256.2C273 259.2 271.5 261 272.1 264.2C272.7 267.4 274.8 268.5 278.4 270.3C282.1 272.1 286.7 274.4 287.8 280.4C288.9 286.4 285.5 290.2 282.7 293.3C280 296.3 278.5 298.1 279.1 301.3C279.7 304.5 281.8 305.6 285.4 307.4C289.1 309.2 293.7 311.5 294.8 317.5C295.9 323.5 292.5 327.3 289.7 330.4C287 333.4 285.5 335.2 286.1 338.4C286.4 340 285.1 341.6 283.2 342Z",
    fill: "#EDDABE"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M130.3 92.2L436.6 98.6C440.5 98.7 443.6 100.7 443.5 103L443.3 107.5C443.2 109.8 440 111.6 436.1 111.4L130.1 96.1C128.3 96 126.8 95.1 126.8 94C126.9 93 128.5 92.1 130.3 92.2Z",
    fill: "#115249"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_301366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoodle);
export default __webpack_public_path__ + "static/media/Noodle.669adc11.svg";
export { ForwardRef as ReactComponent };